// extracted by mini-css-extract-plugin
module.exports = {"new_entry_button":"data-entry_new_entry_button__3Or-n","text_input":"data-entry_text_input__3CDlI"};